module.exports = __webpack_public_path__ + "img/banner-principal.604ada0c.svg";